$(document).ready(function () {
  $(window).on("click", function (e) {
    if ($(e.target).closest(".read-more-btn").length) {
      e.stopImmediatePropagation()
      var $textContent = $(".collection-banner__additional_text ul")
      var $buttonText = $(".read-more-btn").find("span")

      $textContent.toggleClass("expanded")

      if ($textContent.hasClass("expanded")) {
        $buttonText.text("Read Less")
        $(".read-more-btn").addClass("open")
      } else {
        $buttonText.text("Read More")
        $(".read-more-btn").removeClass("open")
      }
    }
  })
})
